import { ContentReportService } from '@/service/ContentReportService'
import Model from './Model'

export enum ContentType {
  POST = 'POST',
  COMMENT = 'COMMENT',
  MEMBER = 'MEMBER',
}

export interface IContentReports {
  contentId: string
  contentType: ContentType
  groupId: string
  locationId: string
}

export default class ContentReports extends Model {
  constructor(payload: IContentReports) {
    super(payload, ContentReportService)
  }

  get locationId(): string {
    return this._data.locationId
  }

  set locationId(locationId: string) {
    this._data.locationId = locationId
  }

  get contentId(): string {
    return this._data.contentId
  }

  set contentId(contentId: string) {
    this._data.contentId = contentId
  }

  get contentType(): ContentType {
    return this._data.contentType
  }

  set contentType(contentType: ContentType) {
    this._data.contentType = contentType
  }

  get groupId(): string {
    return this._data.groupId
  }

  set groupId(groupId: string) {
    this._data.groupId = groupId
  }
}
